import { GridView, TableRows } from '@mui/icons-material'
import { Box, Button, ButtonGroup } from '@mui/material'
import CustomGrid from 'common/components/CustomGrid'
import { useEffect, useState } from 'react'
import useFetchHojasGastoLin from '../hooks/useFetchHojasGastoLin'
import HojasGastoLinCard from './ExpenseCard'
import { HojasGastoLinTable } from './HojasGastoLinTable'
export const HojasGastoLin = ({
  disableAll,
  id,
  fechaInicio,
  fechaFin,
  handleChangeState,
  encr,
  showButton,
  updateTotalAmount = () => {},
  forceUpdate = 0,
}) => {
  const [lineas, setLineas] = useState([])
  const [iterator, setIterator] = useState(forceUpdate)
  const { response, error, loading } = useFetchHojasGastoLin({ id_hoja: id, encr, iterator })
  const [viewType, setViewType] = useState('TABLE')

  useEffect(() => {
    if (response) setLineas(response)
  }, [response])

  useEffect(() => {
    setIterator(iterator + 1)
  }, [forceUpdate])

  const handleNewExpense = (linea) => {
    debugger
    handleChangeState(linea)
    setIterator(iterator + 1)
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <ButtonGroup sx={{ display: { xs: 'none', lg: 'flex' } }}>
          <Button
            variant={viewType === 'TABLE' ? 'contained' : 'text'}
            onClick={() => {
              setViewType('TABLE')
            }}
          >
            <TableRows />
          </Button>
          <Button
            variant={viewType === 'TABLE' ? 'text' : 'contained'}
            onClick={() => {
              setViewType('GRID')
            }}
          >
            <GridView />
          </Button>
        </ButtonGroup>
      </Box>
      <Box
        sx={{
          display: { xs: 'flex', lg: 'none' },
          justifyContent: 'center',
          textAlign: 'center',
          alignItems: 'center',
          alignContent: 'center',
          width: '100%',
          placeItems: 'center',
        }}
      >
        <Box sx={{ mt: 2, width: '100%' }}>
          <CustomGrid
            loading={loading}
            dataSource={lineas ?? []}
            count={lineas?.count}
            gridProps={{ spacing: 2 }}
            gridItemsProps={{ size: { xs: 12, md: 6, sm: 6 } }}
            CardLayout={({ data }) => (
              <>
                <HojasGastoLinCard
                  data={data}
                  lineas={lineas}
                  setLineas={setLineas}
                  loading={loading}
                  id_hoja={id}
                  disableAll={disableAll}
                  fechaInicio={fechaInicio}
                  fechaFin={fechaFin}
                  showButton={showButton}
                  handleChangeState={handleNewExpense}
                  encr={encr}
                />
              </>
            )}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: { xs: 'none', lg: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center',
          width: '100%',
        }}
      >
        {viewType === 'TABLE' ? (
          <HojasGastoLinTable
            lineas={lineas}
            setLineas={setLineas}
            loading={loading}
            id_hoja={id}
            disableAll={disableAll}
            fechaInicio={fechaInicio}
            fechaFin={fechaFin}
            showButton={showButton}
            handleChangeState={handleNewExpense}
            encr={encr}
          />
        ) : (
          <>
            <Box sx={{ mt: 2, width: '100%' }}>
              <CustomGrid
                loading={loading}
                dataSource={lineas ?? []}
                count={lineas?.count}
                gridProps={{ spacing: 2 }}
                gridItemsProps={{ size: { xs: 12, md: 6, sm: 4 } }}
                CardLayout={({ data }) => (
                  <>
                    <HojasGastoLinCard
                      data={data}
                      lineas={lineas}
                      setLineas={setLineas}
                      loading={loading}
                      id_hoja={id}
                      disableAll={disableAll}
                      fechaInicio={fechaInicio}
                      fechaFin={fechaFin}
                      showButton={showButton}
                      handleChangeState={handleNewExpense}
                      encr={encr}
                    />
                  </>
                )}
              />
            </Box>
          </>
        )}
      </Box>
    </>
  )
}
